import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconHomeLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 18.442h3.346v-5.038c0-.256.087-.47.26-.644a.875.875 0 0 1 .644-.26h3.5c.256 0 .47.087.644.26.173.173.26.388.26.644v5.038H18V9.596a.288.288 0 0 0-.034-.14.375.375 0 0 0-.091-.11l-5.692-4.279A.269.269 0 0 0 12 5a.269.269 0 0 0-.183.067L6.125 9.346a.374.374 0 0 0-.091.11.288.288 0 0 0-.034.14v8.846Zm-1.5 0V9.596a1.794 1.794 0 0 1 .723-1.446l5.692-4.289A1.737 1.737 0 0 1 12 3.5c.406 0 .768.12 1.085.361l5.693 4.289a1.794 1.794 0 0 1 .723 1.446v8.846c0 .41-.148.761-.443 1.057a1.443 1.443 0 0 1-1.057.443h-3.942a.874.874 0 0 1-.644-.26.874.874 0 0 1-.26-.644V14h-2.308v5.038a.872.872 0 0 1-.26.644.874.874 0 0 1-.644.26H6c-.409 0-.761-.148-1.057-.443a1.443 1.443 0 0 1-.443-1.057Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconHomeLine;
